import { Audio, Images, Tweens } from "@abcya/abcya_phaser";
import GatorSmall from "../game/GatorSmall";
import NounVerbs from "../game/NounVerbs";
import gameData from "../gameData";
import TutorialScene from "../scenes/TutorialScene";
import UIAssetKeys from "../UIAssetKeys";
import Popup from "./Popup";

export default class NavBar extends Phaser.GameObjects.Container
{
	constructor(scene, type)
	{
		super(scene)

		this.type = type;

		this.soundCont = null;
		this.levelCont = null;
		this.sound = null;
		this.mute = null;
		this.pause = null;

		this.tray = null;
		this.scoreBar = null;
		this.scoreMask = null;

		this.timer = null;
		this.timeText = null;
		this.nounText = null;
		this.scoreText = null;

		this.isActive = null;

		//create Tray
		this.trayCont = this.scene.add.container();

		this.tray = Images.addImage(0, 0, UIAssetKeys._UIBar, this.trayCont);
		this.tray.setOrigin(.5,0);
		this.trayCont.setPosition(this.scene.scale.width/2, -this.tray.height);//-this.tray.height

		//create score
		this.scoreBar = Images.addImage(0, 78, UIAssetKeys._ProgressBar, this.trayCont);
		this.scoreBar.setOrigin(.5, .5);

		this.scoreMask = this.scene.add.graphics(0, 0);
		this.scoreMask.fillStyle(0xFFFFFF, 0);
		this.scoreMask.beginPath();
		this.scoreMask.fillRect(0, 0, 320, 90);


		const mask = this.scoreMask.createGeometryMask();

		this.scoreMask.setPosition(this.scene.scale.width/2-475, 30);
		this.scoreBar.setMask(mask);

		//create level

		this.levelCont = this.scene.add.container();
		this.trayCont.add(this.levelCont);

		const levelBG = Images.addImage(0,  0, UIAssetKeys._LevelLabel, this.levelCont);
		levelBG.setOrigin(.5, .5);

		this.levelText = this.scene.add.bitmapText(-15, 5, "font1", String(gameData.currentLevel), 28);
		this.levelText.setOrigin(.5, .5);
		this.levelCont.add(this.levelText);
		const maxText = this.scene.add.bitmapText(10, 5, "font1", "/ " + String(gameData.levels), 28);
		maxText.setOrigin(.5, .5);
		this.levelCont.add(maxText);

		this.levelCont.setPosition(-this.scene.scale.width/2 + levelBG.width/2 + 10, levelBG.height/2 + 10);

		//create buttons

		this.soundCont = this.scene.add.container();
		this.trayCont.add(this.soundCont);

		this.mute = Images.addImage(0,  0, UIAssetKeys._MuteButton, this.soundCont).setOrigin(0);
		this.sound = Images.addImage(0,  0, UIAssetKeys._VolumeButton, this.soundCont).setOrigin(0);
		this.pause = Images.addImage(0,  0, UIAssetKeys._pauseBtn, this.trayCont).setOrigin(0);
		this.pause.setOrigin(.5, .5);
		this.pause.setScale(1.1, 1.1);

		this.mute.setOrigin(.5, .5);
		this.sound.setOrigin(.5, .5);
		this.soundCont.setPosition(this.scene.scale.width/2 - 120, this.sound.height/2 + 5);
		this.pause.setPosition(this.scene.scale.width/2 - this.pause.width/2 - 10, this.pause.height/2 + 9);

		if(!gameData.mute){
			this.mute.alpha = 0;
		} else {
			this.sound.alpha = 0;
		}

		//create timer

		this.timeText = this.scene.add.bitmapText(0, 40, "font1", this.initTime(), 44);
		this.timeText.setOrigin(.5, .5);
		this.trayCont.add(this.timeText);

		if(gameData.currentScene !== "TutorialScene") {

			//this.timer = game.time.events.loop(Phaser.Timer.SECOND, this.tick, this);
			this.timer = this.scene.time.addEvent({
				delay: 1000,                // ms
				callback: ()=>{this.tick()},
				loop: true
			});

		}

		Tweens.addTween(this.trayCont, 1000, {y: 0}, Phaser.Math.Easing.Quadratic.Out,()=>{
			this.enableButtons();
		})

		this.noun;

		if(gameData.currentLevel === 1){
			if(gameData.currentScene === "TutorialScene"){
				this.noun = "The Kids";
			}
			else {
				this.noun = NounVerbs.singleNouns[Math.floor(Math.random() * NounVerbs.singleNouns.length)];
			}
			gameData.nounType = "singular";
		}
		else if(gameData.currentLevel === 2){
			this.noun = NounVerbs.pluralNouns[Math.floor(Math.random() * NounVerbs.pluralNouns.length)];
			gameData.nounType = "plural";
		}
		else {
			const randType = Math.floor(Math.random() * 2);
			if(randType === 1){
				this.noun = NounVerbs.singleNouns[Math.floor(Math.random() * NounVerbs.singleNouns.length)];
				gameData.nounType = "singular";
			} else {
				this.noun = NounVerbs.pluralNouns[Math.floor(Math.random() * NounVerbs.pluralNouns.length)];
				gameData.nounType = "plural";
			}
		}

		this.nounText = this.scene.add.bitmapText(0, 0, "font1", this.noun + "...", 80);
		this.add(this.nounText);
		this.nounText.setOrigin(.5, 1);
		this.nounText.tint = "0xFFFDC5";

		const nounTextY = (this.nounText.fontData.lineHeight == 49) ? 230 : 240; //this is a lineHeight workaround - because line height affects all created bitmap text

		this.nounText.setPosition(this.scene.scale.width/2, nounTextY);
		
		this.gator = new GatorSmall(this.scene)
	}

	tick() {
		gameData.time--;

		var minutes = Math.floor(gameData.time / 60);
		var seconds = gameData.time - (minutes * 60);

		this.timeText.text = this.addZeros(minutes) + ":" + this.addZeros(seconds);

		if (gameData.time === 0) {
			this.scene.time.removeEvent(this.timer);
			this.timer = null;

			for(var g=0; g<this.scene.gators.length; g++){
				this.scene.gators[g].disableInteractive();
			}
			for(var a=0; a<this.scene.activeGators.length; a++){
				this.scene.activeGators[a].disableInteractive();
			}

			this.popup = new Popup(this.scene, 'TimesUp', this);
			this.scene.add.existing(this.popup);

			this.disableButtons();

			this.scene.allHide();

			this.timeText.text = "Game Over";
			this.timeText.fontSize = 40;
			gameData.gameOver = true;
		}
	};

	addZeros(num) {
		if (num < 10) {
			num = "0" + num;
		}
		return num;
	};

	resumeGame(){
		//console.log("RESUMING");
		this.popup.destroy();
		this.popup = null;

		this.scene.tweens.resumeAll();

		if(this.timer) this.timer.paused = false;

		this.emit('Unpause');

		this.enableButtons();
	};

	enableButtons(){
		this.pause.setInteractive();
		this.pause.removeListener('pointerdown');
		this.pause.on('pointerdown', this.pauseGame, this);

		if(!gameData.mute){
			this.sound.setInteractive();
			this.sound.removeListener('pointerdown');
			this.sound.on('pointerdown', this.toggleSound, this)
		} else {
			this.mute.setInteractive();
			this.mute.removeListener('pointerdown');
			this.mute.on('pointerdown', this.toggleSound, this);
		}
	};

	disableButtons() {
		//console.log("disabling");
		if(this.pause) this.pause.disableInteractive();
		if(this.mute) this.mute.disableInteractive();
		if(this.sound) this.sound.disableInteractive();
	};

	pauseGame(){
		//console.log("PAUSING");
		if(!gameData.mute) Audio.playOneShot("gator_pop", this.scene);

		this.scene.tweens.pauseAll();

		this.disableButtons();

		if(this.timer) this.timer.paused = true;

		this.popup = new Popup(this.scene, "Paused", this);
		this.scene.add.existing(this.popup);

		this.emit('Paused');
	};

	initTime() {
		const minutes = Math.floor(gameData.time / 60);
		const seconds = gameData.time - (minutes * 60);
		return this.addZeros(minutes) + ":" + this.addZeros(seconds);
	};

	toggleSound(){

		Audio.playOneShot("gator_pop", this.scene);

		if(!gameData.mute){
			gameData.mute = true;
			this.scene.sound.setMute(true);
			this.mute.alpha = 1;
			this.sound.alpha = 0;
			this.scene.sound.stopAll();
		} else {
			this.scene.sound.stopAll();
			this.scene.sound.setMute(false);
			gameData.mute = false;
			this.mute.alpha = 0;
			this.sound.alpha = 1;
			Audio.playOneShot("later_gator_jingle", this.scene, .3, true);

		}

		this.enableButtons();
	};

	updateScore(num) {
		//console.log("updating score");
		gameData.score += num;

		//console.log(gameData.score, num);

		if(gameData.score <= gameData.questions) {
			if(gameData.score >= 0) this.updateProgress(num);

			if(gameData.score === gameData.questions){

				gameData.gameOver = true;
				gameData.currentLevel++;

				this.disableButtons();

				if(this.timer) {
					this.scene.time.removeEvent(this.timer);
					this.timer = null;
				}

				for(var g=0; g<this.scene.gators.length; g++){
					this.scene.gators[g].disableInput();
				}
				for(var a=0; a<this.scene.activeGators.length; a++){
					this.scene.activeGators[a].disableInput();
				}

				if(gameData.currentLevel > gameData.levels){
					this.popup = new Popup(this.scene, "Score", this);
					this.scene.add.existing(this.popup);
				} else {
					this.popup = new Popup(this.scene, "LevelComplete", this);
					this.scene.add.existing(this.popup);
				}
			}
		}

		if(gameData.score < 0) gameData.score = 0;
	};

	updateProgress(dir) {
		//console.log("updating progress!");
		let scoreAdj;
		if(dir > 0) {
			scoreAdj = this.scoreBar.width/(gameData.questions) + 1;
		} else {
			scoreAdj = -this.scoreBar.width/(gameData.questions) - 1;
		}

		Tweens.addTween(this.scoreMask, 500, {x: this.scoreMask.x + scoreAdj}, Phaser.Math.Easing.Quadratic.Out);

		this.gator.chomp(dir);
	};

	cleanUp(){
		gameData.gameOver = false;
		gameData.gamePaused = false;

		if(this.timer) {
			this.scene.time.removeEvent(this.timer);
			this.timer = null;
		}

		this.disableButtons();

		this.nounText.destroy();
		this.trayCont.destroy();
		this.pause.destroy();
		this.soundCont.destroy();
		this.levelCont.destroy();

		if(this.popup){
			//this.popup.cleanUp();
			this.popup.destroy();
			this.popup = null;
		}
	};

	tweenNoun() {
		// console.log("creating noun", this.scene);
		for(let g=0; g<this.scene.activeGators.length; g++){
			this.scene.activeGators[g].disableInput();
		}


		Tweens.addTween(this.nounText, 500, {scaleY: 0}, Phaser.Math.Easing.Quadratic.Out, ()=>this.changeNoun());
	};

	changeNoun() {
		// console.log("CHANGING noun");
		
		if(gameData.currentLevel === 1){
			this.noun = NounVerbs.singleNouns[Math.floor(Math.random() * NounVerbs.singleNouns.length)];
			gameData.nounType = "singular";
		}
		else if(gameData.currentLevel === 2){
			this.noun = NounVerbs.pluralNouns[Math.floor(Math.random() * NounVerbs.pluralNouns.length)];
			gameData.nounType = "plural";
		}
		else {
			const randType = Math.floor(Math.random() * 2);
			if(randType === 1){
				this.noun = NounVerbs.singleNouns[Math.floor(Math.random() * NounVerbs.singleNouns.length)];
				gameData.nounType = "singular";
			} else {
				this.noun = NounVerbs.pluralNouns[Math.floor(Math.random() * NounVerbs.pluralNouns.length)];
				gameData.nounType = "plural";
			}
		}

		this.nounText.text = this.noun + "...";

		Tweens.addTween(this.nounText, 500, {scaleY:1}, Phaser.Math.Easing.Quadratic.Out, ()=>this.enableGators())
	};

	enableGators = function() {
		//console.log("creating timer");
		for(var g=0; g<this.scene.activeGators.length; g++){
			if(!this.scene.activeGators[g].isHiding) this.scene.activeGators[g].enableInput();
		}
	};
}

/*

	me.createGator = function() {
		//console.log("creating timer");
		this.gator = new ABCya.GatorSmall(this.game, this);
	};

	me.toggleSound = function(){
		Audio.playOneShot("gator_pop");

		if(!gameData.mute){
			gameData.mute = true;
			this.mute.alpha = 0;
			this.sound.alpha = 1;
			ABCya.audio.stopSound("later_gator_jingle");
		} else {
			gameData.mute = false;
			this.mute.alpha = 1;
			this.sound.alpha = 0;
			Audio.playOneShot("later_gator_jingle", 0, true, .3);
		}
	};
})();*/